const getSchemaFoSchemaKind = (item, schema) => {
  const updatedSchema = JSON.parse(JSON.stringify(schema))
  if (item?.kind === 'literal') {
    delete updatedSchema.value['enum']
    delete updatedSchema.value['options']
  }
  return updatedSchema
}

const getFieldsForSchemaKind = (item, fields) => {
  const updatedFields = JSON.parse(JSON.stringify(fields))
  if (item?.kind === 'literal') {
    updatedFields.forEach((field) => {
      if (field.name === 'value') {
        delete field.options
        delete field.enum
      }
    })
  }
  return updatedFields
}

export { getFieldsForSchemaKind, getSchemaFoSchemaKind }
